class LanguageSwitcher extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['country', 'language']
  }

  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleCountryChange = this.handleCountryChange.bind(this)

    this.listeners.add(this.countrySelect, 'change', this.handleCountryChange)
  }

  handleCountryChange (event) {
    const selectedOption = event.target.options[event.target.selectedIndex]
    const languagesData = selectedOption.getAttribute('data-languages')
    const languagesCount = parseInt(
      selectedOption.getAttribute('data-language-count'),
    )

    this.languageSelect.innerHTML = ''

    this.els['language-panel'].element.setAttribute(
      'aria-hidden',
      languagesCount < 2,
    )

    if (languagesData) {
      const languagesArray = languagesData.split(',')

      languagesArray.forEach((lang) => {
        const [isoCode, endonymName] = lang.split(':')

        const option = document.createElement('option')
        option.value = isoCode
        option.textContent = `${endonymName} - ${isoCode.toUpperCase()}`

        this.languageSelect.appendChild(option)
      })
    }
  }

  get countrySelect () {
    return this.els.country.element
  }

  get languageSelect () {
    return this.els.language.element
  }
}

if (!customElements.get('language-switcher')) {
  customElements.define('language-switcher', LanguageSwitcher)
}
